module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/other-312.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/wechat/other.md
// module id = 782
// module chunks = 414